export default ({ request }) => ({
  customerDevTrackingQuotationDetailApi({ devTrackingQuotationNo } = {}) {
    return request({
      url: `/digitalCenter/customer/dev/tracking/quotation/detail/${devTrackingQuotationNo}`,
      method: 'GET',
    })
  },
  customerDevTrackingQuotationDetailTaskApi({ tskInfoNo } = {}) {
    return request({
      method: 'GET',
      url: `/digitalCenter/customer/dev/tracking/quotation/detail/task/${tskInfoNo}`,
    })
  },
  customerDevTrackingQuotationProductApi({ devTrackingQuotationNo } = {}) {
    return request({
      method: 'GET',
      url: `/digitalCenter/customer/dev/tracking/quotation/product/${devTrackingQuotationNo}`,
    })
  },
  customerDevTrackingQuotationProductTaskApi({ tskInfoNo } = {}) {
    return request({
      method: 'GET',
      url: `/digitalCenter/customer/dev/tracking/quotation/product/task/${tskInfoNo}`,
    })
  },
  customerDevTrackingQuotationFabricOptionsApi(data = {}) {
    return request({
      method: 'POST',
      url: `/digitalCenter/customer/dev/tracking/quotation/fabric/options`,
      data,
    })
  },
  customerDevTrackingQuotationFabricListApi(data = {}) {
    return request({
      method: 'POST',
      url: `/digitalCenter/customer/dev/tracking/quotation/fabric/list`,
      data,
    })
  },
  customerDevTrackingQuotationSaveApi(data = {}) {
    return request({
      method: 'POST',
      url: `/digitalCenter/customer/dev/tracking/quotation/save`,
      data,
    })
  },
  customerDevTrackingQuotationTaskAddApi(data = {}) {
    return request({
      method: 'POST',
      url: `/digitalCenter/customer/dev/tracking/quotation/task/add`,
      data,
    })
  },
  customerDevTrackingQuotationSampleListApi(data = {}) {
    return request({
      method: 'POST',
      url: `/digitalCenter/customer/dev/tracking/quotation/sample/list`,
      data,
    })
  },
})
